import { z } from 'zod';

export const waitlistSourceSchema = z.enum(['hero', 'final-cta', 'top-bar', 'blog', 'other']);

export type WaitlistSource = z.infer<typeof waitlistSourceSchema>;

export const waitlistExperienceLevelSchema = z.enum([
  'student',
  'bootcamp',
  'self-taught',
  'junior',
  'mid',
  'senior',
  'other',
]);

export type WaitlistExperienceLevel = z.infer<typeof waitlistExperienceLevelSchema>;

export const waitlistInputSchema = z.object({
  // BR-20: email trimmed + lowercased, max 254 chars — normalization applied
  // before the uniqueness check.
  email: z.string().trim().toLowerCase().email().max(254),
  experienceLevel: waitlistExperienceLevelSchema.optional(),
  aiTools: z.array(z.string().trim().min(1).max(80)).max(20).optional(),
  mainPain: z.string().trim().max(1000).optional(),
  source: waitlistSourceSchema.optional().default('other'),
  referrer: z.string().max(512).optional(),
  utmSource: z.string().max(120).optional(),
  utmMedium: z.string().max(120).optional(),
  utmCampaign: z.string().max(120).optional(),
  /** Honeypot — must be empty when received. */
  website: z.string().max(0).optional(),
  /** Cloudflare Turnstile challenge token. */
  turnstileToken: z.string().optional(),
});

export type WaitlistInput = z.infer<typeof waitlistInputSchema>;
